<template>
  <tr
      :class="[   item.submitted ? 'submitted' : '' ]"
      @click="setWorkerIfNotAdmin"
  >
    <td class="name_col"
        v-if="item.payment_reference_type === 'W'"
        @click="setWorkerIfNotAdmin"
    >
      {{ item.first_name }} {{ item.surname }} - {{ item.job_title }}
    </td>
    <td class="name_col"
        v-else
        @click="setWorkerIfNotAdmin"
    >
      {{item.company_trading_name}} - {{ item.first_name }} {{ item.surname }}
    </td>

    <td class="rate_col">
      <router-link :to="{name: 'worker_profile', query:{worker_id: item.worker_id}}">
        ({{item.payment_reference_type}}) {{ item.payment_reference }}
      </router-link>
    </td>

    <td class="rate_col">
      <Rate :data="item.rate"/>
    </td>

    <template v-if="item && item.payments && item.geo && !isGeoAllZero(item.geo)">
      <td class="geo_col">
        <button
            :disabled="item.submitted"
            class="geo_button"
            type="button"
            @click="setWorkerIfNotAdmin"
        >
          Geo
        </button>
      </td>
    </template>
    <td v-else class="geo_col">-</td>

    <td :class="'status_col ' + item.status_name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '')">{{item.status_name}}</td>

    <td
        v-for="(payItem, payIndex) in item.payments"
        class="day_col"
    >
      <payday_input_horizontal
          v-model="item.payments[payIndex]"
          :disabled="true"
          :rowIndex="payIndex"
          :timesheetId="item.id"
          @click="() => setWorkerIfNotAdmin"
          @validate="() => validateRow(payIndex)"
      />
    </td>

    <td class="checkbox_col">
      <checkbox_input
          v-model="item.back_next_week"
          :disabled="true"
          :hideTextValue="true"
          class="switch"
          name=""
      />
    </td>

    <td class="checkbox_col">
      <checkbox_input
          v-model="item.retention_released"
          :disabled="true"
          :hideTextValue="true"
          class="switch"
          name=""
      />
    </td>

    <template>
      <td class="total_col">{{ item.totalPriceForHours | currency }}</td>
      <td class="total_col">{{ item.totalAdditionsDeductions | currency }}</td>
      <td class="total_col">
        {{ item.totalPriceForHours + item.totalAdditionsDeductions | currency }}
      </td>
    </template>

    <td class="button_col">
      <template v-if="adminActive">
        <template v-if="item.status_name === 'paid'">
          <AdminReopenTimesheetButton
              :company-id="company_id"
              :timesheet-id="item.timesheet_id"
              :admin-busy="adminBusy"
              :with-admin-lock="withAdminLock"
              :success="async ()=>{await onRefresh(item.timesheet_id);}"
              :hard="true"
          />
          <AdminResetTimesheetButton
              :company-id="company_id"
              :timesheet-id="item.timesheet_id"
              :admin-busy="adminBusy"
              :with-admin-lock="withAdminLock"
              :success="async ()=>{await onRefresh(item.timesheet_id);}"
              :hard="true"
          />
        </template>
        <template v-else>
          <AdminReopenTimesheetButton
              :company-id="company_id"
              :timesheet-id="item.timesheet_id"
              :admin-busy="adminBusy"
              :with-admin-lock="withAdminLock"
              :success="async ()=>{await onRefresh(item.timesheet_id);}"
          />

          <AdminResetTimesheetButton
              :company-id="company_id"
              :timesheet-id="item.timesheet_id"
              :admin-busy="adminBusy"
              :with-admin-lock="withAdminLock"
              :success="async ()=>{await onRefresh(item.timesheet_id);}"
          />
        </template>
      </template>
      <template v-else>
        <div v-if="item && item.submitted" class="row_status">
          <router-link
              :to="{ name: 'a_timesheet_edit_worker', params: { company_id, start_date, end_date, order_job_id: item.order_job_id, timesheet_id: item.timesheet_id } }"
          >
            <button
                class="timesheet_button"
            >
              <span>View</span>
            </button>
          </router-link>
        </div>
      </template>
    </td>
  </tr>
</template>

<style scoped>
@import '../../components/shared/css/workers-table.css';
</style>

<script>

import checkbox_input from "../../components/timesheet_edit_timesheet/toggle_checkbox.vue";
import PaydayInputHorizontal from "../../components/timesheet_edit_timesheet/payday_input_horizontal.vue";
import Rate from "../../components/shared/Rate.vue";
import {isGeoAllZero} from "pages/sunset/timesheets/components/shared";
import AdminReopenTimesheetButton from './AdminReopenTimesheetButton.vue';
import AdminResetTimesheetButton from './AdminResetTimesheetButton.vue';

export default {
  components: {
    checkbox_input,
    payday_input_horizontal: PaydayInputHorizontal,
    Rate,
    AdminResetTimesheetButton,
    AdminReopenTimesheetButton
  },
  props: {
    company_id: {required: true},
    start_date: {required: true},
    end_date: {required: true},
    loading: {required: true, type: Boolean},
    saving: {required: true, type: Boolean},
    applyGeoToPayments: {required: true, type: Function},
    item: {required: true, type: Object},
    setWorker: {required: true, type: Function},
    index: {required: true, type: Number},
    adminActive: { type: Boolean, required: true },
    adminBusy: { type: Boolean, required: true },
    withAdminLock: { type: Function, required: true },
    onRefresh: { type: Function, required: true },
  },
  methods:{
    isGeoAllZero,
    setWorkerIfNotAdmin() {
      if (this.adminActive) return;
      this.setWorker(this.index);
    },
  }
}
</script>